//core
import React, {useRef, useEffect, useContext} from "react";
import { LinearProgress } from "@mui/material";
import Lottie from "lottie-react";

//styles
import classes from "./styles/styles.module.scss";

//img
import { BRAND, TITLE } from "../../../api";

//context
import { ThemeContext } from "../MuiTheme/context";

//afft loader
import afftAnimation from "./data/afft.json";
import grpAnimation from "./data/grp.json";
//import batAnimation from "./data/bat.json";

const AppLoader: React.FC = () => {
  const lottieRef = useRef<any>(null);
  const context = useContext(ThemeContext);

  useEffect(() => {
    if (lottieRef.hasOwnProperty('current') && !!lottieRef.current) {
      if (BRAND === 'bat') {
        lottieRef?.current.setSpeed(6);
      } else {
        lottieRef?.current.setSpeed(4);
      }
    }
  }, [lottieRef]);

  return (
    <div className={classes.loader}>
      <div className={`${classes.logo} ${BRAND === 'bat' ? classes.large : ''}`}>
        {BRAND === 'afft' ? (
          <Lottie animationData={afftAnimation} loop={true} />
        ) : BRAND === 'grp' ? (
          <Lottie lottieRef={lottieRef} animationData={grpAnimation} loop={true}  />
        ) : (
          <>
            {BRAND === 'bat' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.56`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.56`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'lxa' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.56`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.56`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'gca' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.56`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.56`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'btfp' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.57`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.57`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'pmaff' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.85`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.85`} alt={TITLE}/>
                )}
              </>
            ): BRAND === 'vph' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.92`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.92`} alt={TITLE}/>
                )}
              </>
            ): BRAND === 'alfwn' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.96`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.96`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'lirv' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.97`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.97`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'koor' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.97`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.97`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'slpkng' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.97`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.97`} alt={TITLE}/>
                )}
              </>
            ): BRAND === 'mngd' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.97`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.97`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'pmvip' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.101`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.101`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'crpb' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.101`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.101`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'lxbp' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.101`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.101`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'nvdp' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.102`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.102`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'betb' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.102.1`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.102.1`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'redf' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.105.1`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.105.1`} alt={TITLE}/>
                )}
              </>
            ) : BRAND === 'cmdf' ? (
              <>
                {context.darkMode ? (
                  <img src={`/assets/images/logo/${BRAND}/logo-solid.svg?v=1.105.2`} alt={TITLE}/>
                ) : (
                  <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.105.2`} alt={TITLE}/>
                )}
              </>
            ) : (
              <img src={`/assets/images/logo/${BRAND}/logo-large.svg?v=1.106`} alt={TITLE}/>
            )}
          </>
        )}
      </div>
      <div className={classes.progress}>
        <LinearProgress />
      </div>
    </div>
  );
};

export default AppLoader;
